export default __webpack_public_path__ + "images/HV.1184f0d.png";